// Module
var code = "<div flex layout=\"column\" class=\"md-padding\">\r\n\r\n    <h3 translate-once=\"general_default_values\"></h3>\r\n    \r\n</div>\r\n";
// Exports
module.exports = code;